<template>
    <v-main>
            <v-container fluid >
                <v-layout justify-center>
                    <v-flex xs12 sm12 md12 lg12 xl12 >
                        <v-card 
                            class="mx-auto"  
                            :loading="loading" 
                            @loadingStart="loading=true"
                            @loadingStop="loading=false"
                            >
                            <v-system-bar dark light color="teal darken-1" style="color:#FFF;">
                                <v-spacer></v-spacer><b>Sistema de Control Presupuestal</b><v-spacer></v-spacer>
                            </v-system-bar>
                            <router-view></router-view>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
</template>

<script>
export default {
    data: () => ({
        loading: false,
    })
}
</script>